import { render } from "./plantCareSection.vue?vue&type=template&id=28ff6c40&scoped=true"
import script from "./plantCareSection.vue?vue&type=script&lang=js"
export * from "./plantCareSection.vue?vue&type=script&lang=js"

import "./plantCareSection.vue?vue&type=style&index=0&id=28ff6c40&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28ff6c40"]])

export default __exports__